import {
  accountConfidenceLabel,
  bindingQuality,
  hasEvidenceLink,
  hasSalesforceAccount,
  text,
} from './bindingQuality';
import { invoiceGroupWarning } from './invoiceGroupWarning.js';

export {
  accountConfidenceLabel,
  hasEvidenceLink,
  hasSalesforceAccount,
};

export const accountExplainabilityText = (row = {}, draftPreview = null) => {
  const action = draftPreview?.evidenceAction || draftPreview?.action || {};
  const accountMatch = row.accountMatch || {};
  const method = text(action.bindingMethod || accountMatch.matchMethod);
  const confidence = text(action.bindingConfidence || accountMatch.confidence);
  const pieces = [
    method || accountConfidenceLabel(method, confidence),
    row.bac && `BAC ${row.bac}`,
    row.productCode || row.oemProductCode || row.normalizedProductCode,
    action.manualOrderItemId || row.accountMatch?.orderItemId || row.orderItemId,
    action.manualReferenceId || row.accountMatch?.referenceId || row.referenceId,
  ].filter(Boolean);
  return pieces.length ? `Matched by ${pieces.join(' + ')}` : 'No account match explanation is available yet.';
};

export const productWarningState = ({ row = {}, draftPreview = null, accountCandidateCount = 0, recurringSuggestion = null } = {}) => {
  const quality = bindingQuality(row, draftPreview);
  const accountMethod = draftPreview?.evidenceAction?.bindingMethod
    || draftPreview?.action?.bindingMethod
    || row.accountMatch?.matchMethod
    || '';
  const accountConfidence = draftPreview?.evidenceAction?.bindingConfidence
    || draftPreview?.action?.bindingConfidence
    || row.accountMatch?.confidence
    || '';
  const hasSuggestedMatch = Boolean(recurringSuggestion && quality.status !== 'linked');
  const invoiceWarning = invoiceGroupWarning(row);
  return {
    missingEvidence: quality.missingEvidenceLink,
    missingAccount: quality.missingSalesforceAccount,
    hasSuggestedMatch,
    invoiceGroupWarning: invoiceWarning,
    suggestionLabel: recurringSuggestion
      ? `${recurringSuggestion.productCode || recurringSuggestion.productFamily} via ${recurringSuggestion.sourceSystem || 'recurring rule'}`
      : '',
    hasAnyWarning: quality.missingEvidenceLink || quality.missingSalesforceAccount || hasSuggestedMatch || Boolean(invoiceWarning),
    hasConflictRisk: quality.missingSalesforceAccount && Number(accountCandidateCount || 0) > 1,
    confidenceLabel: accountConfidenceLabel(accountMethod, accountConfidence),
    explanation: accountExplainabilityText(row, draftPreview),
  };
};
